<div class="share-leave">
    <sync-dialog
      [config]="{
        title: 'Leave shared folder',
        actionButton: 'Leave', 
        cancelButton: 'Cancel',
        subTitle: name,
        isClosable: false,
        onCancelClick: closeDialog,
        onActionClick: leaveShare,
        isButtonLoading: spinner,
      }"
       [isCritical]="true"
      [open]="showDialog"
      [isFullScreen]="isSmallScreen"
    >
    <div class="share-leave-wrapper">
          <p class="body-1 text-wrapper">If you continue, you won’t be able to see future changes to this shared folder.</p>
    </div>
    </sync-dialog> 
  </div>
  